import {useEffect, useState} from 'react';
import {useForm} from 'react-hook-form';
import {useDropsSubscriptionsContext} from '../context/SubscriptionsProvider';
import {IsSubscribedEmailType} from '../types';

export const useDropsForm = () => {
  const {handleSubmit, register, errors, setValue} = useForm<{
    email: string;
  }>({
    mode: 'onSubmit',
  });
  const [loadingState, setLoadingState] = useState(false);
  const {guest} = useDropsSubscriptionsContext();

  useEffect(() => {
    if (isGuestSubscribed(guest)) {
      setValue('email', guest?.email);
    }
  }, [guest]);

  return {
    handleSubmit,
    register,
    errors,
    loadingState,
    setLoadingState,
  };
};

const isGuestSubscribed = (guest?: IsSubscribedEmailType) => {
  if (!guest) {
    return false;
  }

  const atLeastOneSubscription =
    guest.allDrops?.isSubscribed ||
    Object.values(guest.individualDrops).some(value => value);

  return atLeastOneSubscription && guest.email;
};
